import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
// import './pre-a.less';
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";

export default function TwoCitiesAcademic({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: 'Cell Reports重磅：首次揭示成人弱视神经学病理机制，首创全龄优效弱视诊疗方案',
      date: '2026-06',
      desc: '北京时间 2021 年 12 月 14 日，国际顶级学术期刊《Cell Reports》在线发表了由复旦大学附属眼耳鼻喉科医院文雯团队和中科院生物物理所张朋团队领衔的研究成果《成人人类弱视中膝状 - 纹状与皮质 - 顶盖通路的层选择性信号缺失与增强》。该研究联合 3T 和 7T 超高分辨率 BOLD fMRI 技术，结合精心设计的大细胞（M）/ 小细胞（P）通路特异性视觉刺激，对 17 名单侧弱视成人患者和 17 名正常对照者进行了对照研究，取得了里程碑式的发现',
      img: '/images/news/cellReportsAmblyopia5.jpg',
      route: '/newsInfo/cellReportsAmblyopia'
    },
    {
      title: '出圈2026VC！｜集视医疗发布“全龄弱视诊疗黑科技”：基于脑科学机制，突破年龄限制',
      date: '2026-06',
      desc: '津门聚智，睛启新篇！备受行业瞩目的2026视觉健康创新发展国际会议（Vision China 2026）近日在天津圆满落幕。',
      img: '/images/news/jishiAllAgeAmblyopia8.jpg',
      route: '/newsInfo/jishiAllAgeAmblyopia'
    },
    {
      title: '突破弱视诊疗年龄瓶颈，集视医疗携脑科学驱动方案亮相全国小儿眼科年会',
      date: '2026-06',
      desc: '以“脑科学机制驱动・眼脑融合创新”为核心定位的集视医疗，在2026中华医学会斜视与小儿眼科学术大会上精彩亮相，向业界展示了旗下基于脑科学机制的弱视治疗解决方案——埃尔塔（ARTA），与全国眼科专家共探弱视诊疗前沿路径，引发行业广泛关注与认可。',
      img: '/images/news/pediatricConference8.jpg',
      route: '/newsInfo/pediatricConference'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div className="PreA">
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className='article_title'>
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2026.06.07</span>
              </div>
              <div className="article_titleBottom">深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕</div>
            </div>
            <div className='article_content'>
              <div className="article_content-text1">以学术为翼，赴行业之约；以技术为芯，启视界新章。</div>
              <div className="article_content-text">
                6月4日-7日，集视医疗双线奔赴宁波VDT学术交流会、沈阳非公医疗眼科年会双城行业盛会。以学术交流为核心，以技术展示为载体，与全国眼科同仁共探全龄弱视诊疗新方向，共启视光康复行业新机遇。至此，集视双城学术之旅圆满收官！
              </div>
              <div className='article_content-text1'>深耕学术｜宁波VDT交流会，深耕临床共研精进</div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/twoCitiesAcademic1.jpg'
                  alt=''
                />
                <div className='img_tip'>图 | 宁波VDT现场</div>
              </div>
              <div className="article_content-text">
                6月5日，宁波VDT视功能学术交流会圆满落幕。集视医疗受邀参会，全程深耕学术研讨与临床技术交流。<br /><br />
                中国视觉发展与康复（VDT）项目是国内眼视光领域权威的继续医学教育研修体系，本次会议汇聚业内资深眼科专家、一线临床医师，围绕视功能规范化、视觉神经可塑性及弱视数智化诊疗核心议题展开深度探讨。与会嘉宾分享实操经验、研讨落地疗法，共探前沿诊疗方向。<br /><br />
                以交流促成长，以学术助精进。集视医疗全程参会，认真聆听临床一线真实诉求，以视觉通路调节的行业前沿理念，让全年龄段弱视的智能化、精准化诊疗成为可能，并在难治性弱视、斜视、近视、青光眼等领域持续助力视功能诊疗水平提升。
              </div>
              <div className='article_content-text1'>实景亮相｜沈阳非公眼科年会，技术落地赋能行业</div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/twoCitiesAcademic2.jpg'
                  alt=''
                />
                <div className='img_tip'>图 | 沈阳非公医疗眼科年会现场</div>
              </div>
              <div className='article_content-text'>
                6月5日-7日，备受关注的沈阳非公医疗眼科年会盛大启幕，集视携核心技术与全龄弱视诊疗方案埃尔塔（ARTA）重磅亮相18号展位，全方位展示基于弱视神经损伤机制的“双眼”+“双通路”推拉训练方案，成为现场人气焦点。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/twoCitiesAcademic3.jpg'
                  alt=''
                />
                <img
                  style={{ width: '100%' }}
                  src='/images/news/twoCitiesAcademic4.jpg'
                  alt=''
                />
                <div className='img_tip'>图 | 学术分享</div>
              </div>
              <div className='article_content-text'>
                值得一提的是，在专家学术分享环节，再度印证了弱视诊疗的前沿核心逻辑：弱视属于功能性视觉障碍，并非眼部器质性病变，同时临床早已证实，单眼弱视患者的对侧健眼并非完全健康，普遍存在隐匿性视觉功能缺陷。<br /><br />
                这一学术观点，与集视埃尔塔的核心诊疗机制高度契合、完美呼应。区别于传统仅针对弱视单眼的表层训练模式，埃尔塔立足弱视神经病理底层机制，依托双眼分视诊疗原理，进行小细胞通路功能重建的推拉训练，从根源攻克功能性弱视诊疗痛点，为全龄弱视精准、长效康复提供了科学可靠的数智化解决方案。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/twoCitiesAcademic5.png'
                  alt=''
                />
                <img
                  style={{ width: '100%' }}
                  src='/images/news/twoCitiesAcademic6.png'
                  alt=''
                />
                <div className='img_tip'>图 | 展位互动</div>
              </div>
              <div className='article_content-text'>
                展会期间，众多行业同仁莅临展位参观交流、体验测评。现场工作人员细致讲解ARTA埃尔塔核心技术原理，实景演示全年龄段弱视诊疗设备的实操应用，拆解适配多种临床应用场景。<br /><br />
                针对难治性弱视、斜视、视功能异常矫正等临床常见问题，我们结合真实病例，为到场医师提供个性化、可落地的诊疗思路，直击临床痛点，共促眼科诊疗高质量发展。<br /><br />
                严谨的学术态度、直观的设备体验、专业的技术解读、成熟的服务体系，收获了现场同仁的高度认可与一致好评。
              </div>
              <div className='article_content-text1'>初心不改｜以技术为基，守护全民清晰视界</div>
              <div className='article_content-text'>
                从宁波的学术深耕，到沈阳的技术实景展示，双城之行，虽形式不同，初心始终如一。<br /><br />
                多年来，集视医疗始终以「解码眼脑关联，创新视觉干预，守护每一段视觉发育旅程」为使命，深耕眼脑协同交叉学科领域创新。未来，在弱视精准诊疗、筑牢行业技术壁垒的基础上，集视将持续应用前沿眼脑理论与技术，赋能斜视相关视功能训练、近视防控、青光眼缺损视野逆转等更多眼病诊疗赛道，让每个生命都能拥有与世界清晰对话的权利！<br /><br />
                ✨ 如需技术咨询、病例交流、项目合作，可随时私信我们，共话眼科诊疗新未来！
              </div>
              <div className='mt_60 img_tip'>免责声明：本文内容仅供行业学术交流、学术研讨及专业医疗领域参考使用，不构成任何商业广告、产品宣传及诊疗行为推荐。</div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/cellReportsAmblyopia'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/cellReportsAmblyopia'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
